import { Autocomplete, FormControl, TextField } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback, useMemo } from "react";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import { OrdemCompraDropDown } from "../../../../../../common/domain/models/ordem_compra_dropdown";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import DefaultInput from "../../../../../../common/components/default_input";
import { DefaultFornecedor } from "../../../../../../common/components/default_fornecedor_select";
import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";
import { DefaultProduto } from "../../../../../../common/components/default_produtor_select";

type Props = {
  pesquisa: string | null,
  ordemCompra: number[];
  ordemComprasDropdown: OrdemCompraDropDown[];
  handleOrdemCompraChange: (v: number[] | null) => void;
  centroDeCustoLista: { id: number; title: string }[];
  centroDeCusto: number[];
  FornecedorPesquisa: number;
  ProdutorPesquisa: number;
  dataEntradaDe: Date | null;
  dataEntradaAte: Date | null;
  onClearFilters: () => void;
  handleCentroDeCusto: (v: number[]) => void;
  handleFornecedorChange: (v: number) => void;
  handleProdutorChange: (v: number) => void;
  handleDataEntradaRangeChange: (v: Date | null, x: Date | null) => void;
  handlePesquisa: (v: string | null) => void,
};


export const Header = ({ centroDeCusto, centroDeCustoLista, pesquisa, ordemCompra, ordemComprasDropdown, handleOrdemCompraChange, FornecedorPesquisa, dataEntradaAte, dataEntradaDe, ProdutorPesquisa, handleProdutorChange, handleDataEntradaRangeChange, handleFornecedorChange, handleCentroDeCusto, onClearFilters, handlePesquisa }: Props) => {
  const selectedOrdemCompra = useMemo(() => {
    return ordemComprasDropdown.filter(x => ordemCompra.includes(x.idOrdemCompra));
  }, [ordemCompra, ordemComprasDropdown]);

  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);
  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full flex flex-col gap-6">
        <div className="w-full grid gap-4 grid-cols-1 md:grid-cols-2">

          {/* 1. Centro de Custo */}
          <FormControl size="small" fullWidth>
            <Autocomplete
              size="small"
              multiple
              options={centroDeCustoLista}
              value={centroDeCustoLista.filter((i) => centroDeCusto.includes(i.id))}
              getOptionLabel={(i) => i.title}
              onChange={(_, newValue) => {
                handleCentroDeCusto(newValue.map((i) => i.id));
              }}
              isOptionEqualToValue={(opt, val) => opt.id === val.id}
              renderInput={(params) => (
                <TextField {...params} size="small" label="Centro de custo" />
              )}
            />
          </FormControl>

          {/* 2. Fornecedor */}
          <div className="w-full">
            <DefaultFornecedor
              key={`forn-${FornecedorPesquisa}`}
              name="PesquisarFornecedor"
              value={FornecedorPesquisa || null}
              onChange={(valor) => handleFornecedorChange(Number(valor))}
              label="Fornecedor"
            />
          </div>

          {/* 3. Produto */}
          <div className="w-full">
            <DefaultProduto
              key={`prod-${ProdutorPesquisa}`}
              name="PesquisarProdutor"
              value={ProdutorPesquisa || null}
              onChange={(valor) => handleProdutorChange(Number(valor))}
              label="Produto"
              tipo="P"
              incluirCodigoDescricao={true}
            />
          </div>

          {/* 4. Data de Entrada */}
          <div className="w-full">
            <DefaultDateRangePickerInput
              label='Data de Entrada'
              dataDe={dataEntradaDe ?? null}
              dataAte={dataEntradaAte ?? null}
              onChange={async (start, end) => {
                handleDataEntradaRangeChange(start, end)
              }}
            />
          </div>

          {/* 5. Nota Fiscal */}
          <div className="w-full">
            <DefaultInput
              label="Nota Fiscal"
              name="search_by_name"
              value={typeof pesquisa === 'string' ? pesquisa : ''}
              onChangeValue={handlePesquisa}
            />
          </div>

          <div className="w-full">
            <DefaultMultiAutocomplete
              label="Ordem de Compra"
              options={ordemComprasDropdown}
              getOptionKey={x => x.idOrdemCompra}
              getOptionLabel={x => x.descricao}
              value={selectedOrdemCompra}
              onChange={e => handleOrdemCompraChange(e !== null ? e.map(x => x.idOrdemCompra) : null)}
            />
          </div>

          {/* Botão de Limpar (Ocupa as duas colunas na última linha e alinha à direita) */}
          <div className="w-full flex justify-end md:col-span-2 mt-2">
            <div className="w-full md:w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={handleClearFilters}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>

        </div>
      </div>
    </CascateList>
  );
}
